import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from '../constants'

import { DATA_REQUEST_ASYNC } from './constants'

export default function () {
  const initialState = {
    data: {
      total: 0,
      counts: [],
    },
    loader: false,
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case DATA_REQUEST_ASYNC.INITIATE:
      case COMPANY_FILTER_CHANGE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          error: null,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, loader: false, error: action.error?.response }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case SCANBACK_CHANGE:
      case DATE_FILTER_CHANGE:
        return { ...state, loader: true }
      default:
        return state
    }
  }
}
